import React, { useEffect, useState } from "react";
import { createSeparate, getDataItems } from "../../api/Separates";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";

const AddSeparateComponent = (props) => {
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [separateItems, setSeparateItems] = useState(null);
  const [finishingList, setFinishingList] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [loading, setLoading] = useState();
  const [filesChoose, setFilesChoose] = useState({
    logo: null,
  });

  const [formData, setFormData] = useState({
    downPayment: "",
    installmentDuration: "",
    images: [],
    available: false,
    location: "",
    companyName: "",
    description: "",
    name: "",
    types: {
      villas: [
        { price: 0, area: 0, available: false, type: "TOWN" },
        { price: 0, area: 0, available: false, type: "TWIN" },
        { price: 0, area: 0, available: false, type: "STAND-ALONE" },
        { price: 0, area: 0, available: false, type: "S-VILLA" },
      ],
      apartments: [
        { price: 0, area: 0, available: false, type: "STUDIO" },
        { price: 0, area: 0, available: false, type: "ONE-BEDROOM" },
        { price: 0, area: 0, available: false, type: "TWO-BEDROOM" },
        { price: 0, area: 0, available: false, type: "THREE-BEDROOM" },
        { price: 0, area: 0, available: false, type: "FOUR-BEDROOM" },
        { price: 0, area: 0, available: false, type: "DUPLEX" },
        { price: 0, area: 0, available: false, type: "SERVICE-APARTMENT" },
      ],
      mall: [
        { price: 0, area: 0, available: false, type: "SHOP" },
        { price: 0, area: 0, available: false, type: "OFFICE" },
        { price: 0, area: 0, available: false, type: "CLINIC" },
        { price: 0, area: 0, available: false, type: "PHARMACY" },
      ],
    },
    whatsapp_link: "",
    whatsapp: "",
    DeveloperCommission: "",
    CommissionBroker: "",
    CommissionBrokerOnSpot: "",
    CommissionFranchise: "",
    CommissionFranchiseOnSpot: "",
    taxes: "",
  });

  useEffect(() => {
    getDataItems().then((result) => {
      setSeparateItems(result.data);
    });
  }, []);

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 6) {
      alert("Please select a maximum of 6 images");
      return;
    }

    const validTypes = ["image/jpg", "image/png", "image/jpeg"];
    const invalidFiles = files.filter(
      (file) => !validTypes.includes(file.type),
    );

    if (invalidFiles.length > 0) {
      alert("Only JPG, PNG, or JPEG files are allowed");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...files].slice(0, 6),
    }));
  };

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };

  const handleChooseFiles = (e, name) => {
    e.target.setCustomValidity("");
    setFilesChoose((prev) => ({
      ...prev,
      [name]: e.target.files[0],
    }));
  };

  const formatPrice = (value) => {
    return new Intl.NumberFormat().format(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("name", formData.name);
    formBack.append("downPayment", formData.downPayment);
    formBack.append("description", formData.description);
    formBack.append("installmentDuration", formData.installmentDuration);
    formBack.append("finishingType", JSON.stringify(finishingList));
    formBack.append("deliveryStatus", JSON.stringify(deliveryList));
    formBack.append("available", formData.available);
    formBack.append("location", formData.location);
    formBack.append("companyName", formData.companyName);
    formBack.append("types", JSON.stringify(formData.types));
    formBack.append("whatsapp_link", formData.whatsapp_link);
    formBack.append("whatsapp", formData.whatsapp);
    formBack.append("logo", filesChoose.logo);
    formBack.append(
      "DeveloperCommission",
      formData.DeveloperCommission === "" ? 0 : formData.DeveloperCommission,
    );
    formBack.append(
      "CommissionBroker",
      formData.CommissionBroker === "" ? 0 : formData.CommissionBroker,
    );
    formBack.append(
      "CommissionBrokerOnSpot",
      formData.CommissionBrokerOnSpot === ""
        ? 0
        : formData.CommissionBrokerOnSpot,
    );
    formBack.append(
      "CommissionFranchise",
      formData.CommissionFranchise === "" ? 0 : formData.CommissionFranchise,
    );
    formBack.append(
      "CommissionFranchiseOnSpot",
      formData.CommissionFranchiseOnSpot === ""
        ? 0
        : formData.CommissionFranchiseOnSpot,
    );
    formBack.append("taxes", formData.taxes === "" ? 0 : formData.taxes);
    for (let i = 0; i < formData.images.length; i++) {
      formBack.append("images", formData.images[i]);
    }

    createSeparate(formBack).then((result) => {
      if (result.data.message === "Separate is created successfully") {
        toast.success("Separate is created successfully", {
          position: "top-right",
        });
        props.changeToView("View Separates");
      }
      setLoading(false);
    });
  };

  const inputStyle = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    border: 0,
  };

  const labelStyle = {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
  };

  const labelDeleteStyle = {
    display: "inline-block",
    padding: "10px",
    backgroundColor: "red",
    color: "white",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    border: "none",
    textAlign: "center",
    ":hover": {
      backgroundColor: "#45a049",
    },
    margin: "0px",
  };

  const toggleFinishing = (finishing) => {
    setFinishingList((prev) => {
      if (prev.includes(finishing)) {
        return prev.filter((item) => item !== finishing);
      } else {
        return [...prev, finishing];
      }
    });
  };

  const toggleDelivery = (delivery) => {
    setDeliveryList((prev) => {
      if (prev.includes(delivery)) {
        return prev.filter((item) => item !== delivery);
      } else {
        return [...prev, delivery];
      }
    });
  };

  return (
    <>
      {separateItems === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form onSubmit={handleSubmit}>
            <label htmlFor="image">Images</label>
            <div className="image-previews">
              {formData.images.map((image, imageIndex) => (
                <div key={imageIndex} className="preview-item">
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`Preview ${imageIndex}`}
                  />
                  <button onClick={() => removeImage(imageIndex)}>×</button>
                </div>
              ))}
            </div>

            {formData.images.length < 6 && (
              <div className="form-group">
                <div style={{ position: "relative", marginTop: "16px" }}>
                  <input
                    type="file"
                    id="images"
                    name="images"
                    onChange={handleFileChange}
                    multiple
                    accept="image/jpg, image/png, image/jpeg"
                    style={inputStyle}
                    required
                  />
                  <label htmlFor="images" style={labelStyle}>
                    Choose Images ({6 - formData.images.length} remaining)
                  </label>
                </div>
              </div>
            )}

            <div
              className="form-group"
              style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
            >
              <label htmlFor="logo">Developer Logo</label>
              <div style={{ position: "relative", marginTop: "16px" }}>
                {filesChoose.logo && (
                  <div className="preview-item">
                    <img
                      src={URL.createObjectURL(filesChoose.logo)}
                      alt="logo"
                    />
                  </div>
                )}
                <input
                  type="file"
                  id="logo"
                  name="logo"
                  onChange={(e) => handleChooseFiles(e, "logo")}
                  accept="image/jpg, image/png, image/jpeg"
                  style={inputStyle}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Logo english is required")
                  }
                />
                <label htmlFor="logo" style={labelStyle}>
                  {filesChoose.logo ? "Change Logo" : "Choose Logo"}
                </label>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="Developer name">Developer name</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter developer name"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Developer name is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="Title">Title</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Title"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Title is required")
                }
              />
            </div>

            <div className="form-group">
              <label
                htmlFor="location"
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "500",
                }}
              >
                Location
              </label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select location"
                name="location" // Changed from type2 to be more descriptive
                value={formData.location}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    location: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Location is required")
                }
              >
                <option disabled value="">
                  Select Location
                </option>
                {separateItems.cities?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="downPayment">Down payment</label>
                <input
                  type="number"
                  id="downPayment"
                  name="downPayment"
                  value={formData.downPayment}
                  onChange={handleChange}
                  placeholder="Enter Down payment"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Down payment is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="installmentDuration">Years Number</label>
                <input
                  type="number"
                  id="installmentDuration"
                  name="installmentDuration"
                  value={formData.installmentDuration}
                  onChange={handleChange}
                  placeholder="Enter Years Number"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Years Number is required")
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}>
                <div
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    color: "#555",
                  }}
                >
                  <label htmlFor="Finishing">Finishing</label>
                </div>

                <div style={{ paddingBottom: "10px" }}>
                  {separateItems.finishing.map((finishing) => (
                    <div
                      key={finishing}
                      onClick={() => toggleFinishing(finishing)}
                    >
                      <input
                        type="checkbox"
                        checked={finishingList.includes(finishing)}
                        onChange={() => {}}
                        className="client-checkbox"
                      />
                      <label
                        htmlFor="Down payment"
                        style={{ paddingLeft: "10px" }}
                      >
                        {finishing
                          ?.replaceAll("-", " ")
                          ?.toLowerCase()
                          ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}>
                <div
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    color: "#555",
                  }}
                >
                  <label htmlFor="Delivery">Delivery</label>
                </div>

                {separateItems.delivery.map((delivery) => (
                  <div key={delivery} onClick={() => toggleDelivery(delivery)}>
                    <input
                      type="checkbox"
                      checked={deliveryList.includes(delivery)}
                      onChange={() => {}}
                      className="client-checkbox"
                    />
                    <label
                      htmlFor="Down payment"
                      style={{ paddingLeft: "10px" }}
                    >
                      {delivery
                        ?.replaceAll("-", " ")
                        ?.toLowerCase()
                        ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-group">
              <div
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "bold",
                  color: "#555",
                }}
              >
                <label htmlFor="Types">Types</label>
              </div>
            </div>

            <label>Villa</label>

            {formData.types.villas.map((villa, index) => (
              <div key={index}>
                <input
                  id={`villa-${index}`}
                  type="checkbox"
                  checked={villa.available}
                  onChange={() => {
                    setFormData((prev) => ({
                      ...prev,
                      types: {
                        ...prev.types,
                        villas: prev.types.villas.map((villa, villaIndex) =>
                          villaIndex === index
                            ? {
                                ...villa,
                                available: !villa.available,
                                price: 0,
                                area: 0,
                              }
                            : villa,
                        ),
                      },
                    }));
                  }}
                  className="client-checkbox"
                />

                <label
                  htmlFor={`villa-${index}`}
                  style={{ paddingLeft: "10px", cursor: "pointer" }}
                >
                  {villa.type
                    ?.replaceAll("-", " ")
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                </label>
                {villa.available && (
                  <div
                    className="choices-container"
                    style={{
                      display: "flex",
                      width: "100%",
                      gap: "15px", // Better than space-between for consistent spacing
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="form-group"
                      style={{
                        flex: "1 1 calc(50% - 15px)",
                        minWidth: "250px",
                      }}
                    >
                      <label htmlFor="Price">Price</label>
                      <input
                        type="number"
                        id="price"
                        name="price"
                        value={villa.price}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData((prev) => ({
                            ...prev,
                            types: {
                              ...prev.types,
                              villas: prev.types.villas.map(
                                (item, itemIndex) =>
                                  itemIndex === index
                                    ? { ...item, price: value }
                                    : item,
                              ),
                            },
                          }));
                        }}
                        placeholder="Enter Price"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Price is required")
                        }
                      />
                    </div>
                    <div
                      className="form-group"
                      style={{
                        flex: "1 1 calc(50% - 15px)",
                        minWidth: "250px",
                      }}
                    >
                      <label htmlFor="Area">Area</label>
                      <input
                        type="number"
                        id="area"
                        name="area"
                        value={villa.area}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData((prev) => ({
                            ...prev,
                            types: {
                              ...prev.types,
                              villas: prev.types.villas.map(
                                (item, itemIndex) =>
                                  itemIndex === index
                                    ? { ...item, area: value }
                                    : item,
                              ),
                            },
                          }));
                        }}
                        placeholder="Enter Area"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Area is required")
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}

            <label>Apartment</label>

            {formData.types.apartments.map((apartment, index) => (
              <div key={index}>
                <input
                  id={`apartment-${index}`}
                  type="checkbox"
                  checked={apartment.available}
                  onChange={() => {
                    setFormData((prev) => ({
                      ...prev,
                      types: {
                        ...prev.types,
                        apartments: prev.types.apartments.map(
                          (apartment, apartmentIndex) =>
                            apartmentIndex === index
                              ? {
                                  ...apartment,
                                  available: !apartment.available,
                                  price: 0,
                                  area: 0,
                                }
                              : apartment,
                        ),
                      },
                    }));
                  }}
                  className="client-checkbox"
                />

                <label
                  htmlFor={`apartment-${index}`}
                  style={{ paddingLeft: "10px", cursor: "pointer" }}
                >
                  {apartment.type
                    ?.replaceAll("-", " ")
                    ?.toLowerCase()
                    ?.replace(/\b\w/g, (l) => l.toUpperCase())}
                </label>
                {apartment.available && (
                  <div
                    className="choices-container"
                    style={{
                      display: "flex",
                      width: "100%",
                      gap: "15px", // Better than space-between for consistent spacing
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="form-group"
                      style={{
                        flex: "1 1 calc(50% - 15px)",
                        minWidth: "250px",
                      }}
                    >
                      <label htmlFor="Price">Price</label>
                      <input
                        type="number"
                        id="price"
                        name="price"
                        value={apartment.price}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData((prev) => ({
                            ...prev,
                            types: {
                              ...prev.types,
                              apartments: prev.types.apartments.map(
                                (item, itemIndex) =>
                                  itemIndex === index
                                    ? { ...item, price: value }
                                    : item,
                              ),
                            },
                          }));
                        }}
                        placeholder="Enter Price"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Price is required")
                        }
                      />
                    </div>
                    <div
                      className="form-group"
                      style={{
                        flex: "1 1 calc(50% - 15px)",
                        minWidth: "250px",
                      }}
                    >
                      <label htmlFor="Area">Area</label>
                      <input
                        type="number"
                        id="area"
                        name="area"
                        value={apartment.area}
                        onChange={(e) => {
                          const value = e.target.value;

                          setFormData((prev) => ({
                            ...prev,
                            types: {
                              ...prev.types,
                              apartments: prev.types.apartments.map(
                                (item, itemIndex) =>
                                  itemIndex === index
                                    ? { ...item, area: value }
                                    : item,
                              ),
                            },
                          }));
                        }}
                        placeholder="Enter Area"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Area is required")
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                type="text"
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Enter description"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Description is required")
                }
              />
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="whatsapp">WhatsApp number</label>
                <input
                  type="text"
                  id="whatsapp"
                  name="whatsapp"
                  value={formData.whatsapp}
                  onChange={handleChange}
                  placeholder="Enter WhatsApp number"
                  maxLength="11"
                  pattern="^01[0-2,5]\d{1,8}$"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("WhatsApp is required")
                  }
                />
              </div>
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="whatsapp_link">WhatsApp group link</label>
                <input
                  type="text"
                  id="whatsapp_link"
                  name="whatsapp_link"
                  value={formData.whatsapp_link}
                  onChange={handleChange}
                  placeholder="Enter whatsApp group link"
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity(
                      "WhatsApp group link is required",
                    )
                  }
                />
              </div>
            </div>

            <div
              className="choices-container"
              style={{
                display: "flex",
                width: "100%",
                gap: "15px", // Better than space-between for consistent spacing
                flexWrap: "wrap",
              }}
            >
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="DeveloperCommission">
                  Developer commission %
                </label>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <input
                    type="text"
                    id="DeveloperCommission"
                    name="DeveloperCommission"
                    value={formData.DeveloperCommission}
                    onChange={handleChange}
                    placeholder="Enter DeveloperCommission %"
                    pattern="^\d+(\.\d{1,10})?$"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity(
                        "Developer commission is required",
                      )
                    }
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      pointerEvents: "none",
                      color: "#000",
                    }}
                  >
                    %
                  </span>
                </div>
              </div>

              {isSuper && (
                <div
                  className="form-group"
                  style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                >
                  <label htmlFor="taxes">Taxes %</label>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <input
                      type="text"
                      id="taxes"
                      name="taxes"
                      value={formData.taxes}
                      onChange={handleChange}
                      placeholder="Enter taxes %"
                      pattern="^\d+(\.\d{1,10})?$"
                      required
                      onInvalid={(e) =>
                        e.target.setCustomValidity("Taxes is required")
                      }
                    />
                    <span
                      style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#000",
                      }}
                    >
                      %
                    </span>
                  </div>
                </div>
              )}
            </div>

            {isSuper && (
              <>
                <div
                  className="choices-container"
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "15px", // Better than space-between for consistent spacing
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionBroker">
                      Commission broker %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionBroker"
                        name="CommissionBroker"
                        value={formData.CommissionBroker}
                        onChange={handleChange}
                        placeholder="Enter CommissionBroker %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission broker is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionBrokerOnSpot">
                      Commission broker onSpot %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionBrokerOnSpot"
                        name="CommissionBrokerOnSpot"
                        value={formData.CommissionBrokerOnSpot}
                        onChange={handleChange}
                        placeholder="Enter CommissionBrokerOnSpot %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission broker onSpot is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  className="choices-container"
                  style={{
                    display: "flex",
                    width: "100%",
                    gap: "15px", // Better than space-between for consistent spacing
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionFranchise">
                      Commission franchise %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionFranchise"
                        name="CommissionFranchise"
                        value={formData.CommissionFranchise}
                        onChange={handleChange}
                        placeholder="Enter CommissionFranchise %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission franchise is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group"
                    style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
                  >
                    <label htmlFor="CommissionFranchiseOnSpot">
                      Commission franchise onSpot %
                    </label>
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      <input
                        type="text"
                        id="CommissionFranchiseOnSpot"
                        name="CommissionFranchiseOnSpot"
                        value={formData.CommissionFranchiseOnSpot}
                        onChange={handleChange}
                        placeholder="Enter CommissionFranchiseOnSpot %"
                        pattern="^\d+(\.\d{1,10})?$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Commission franchise onSpot is required",
                          )
                        }
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          color: "#000",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  available: !prev.available,
                }))
              }
            >
              <input
                type="checkbox"
                checked={formData.available}
                onChange={() => {}}
                className="client-checkbox"
              />
              <label htmlFor="Available" style={{ paddingLeft: "10px" }}>
                Available
              </label>
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add Separate
              </button>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </>
  );
};

export default AddSeparateComponent;
